/*
  Contact topic pills (Contact Page v2).

  Progressive enhancement only. The markup ships a hidden input already holding
  the default topic and, on a posted-back form, whatever the customer chose — so
  with JS off the form still submits a valid "Inquiry type", the order-number
  field stays visible, and nothing is lost. This layer just makes the pills live:
  mirror the choice into the hidden input, swap the message placeholder for
  something the topic actually asks for, and show the order-number field only
  when it is relevant.
*/
(() => {
  const PLACEHOLDERS = {
    'Product question': 'Which flavor are you asking about, and what are you cooking?',
    'Order question': 'Tell us what happened with the order and when you placed it.',
    'Wholesale inquiry': 'Shop name, city, and the lines you are interested in.',
    'General question': 'Tell us what you need — the more detail, the better.',
  };
  const DEFAULT_PLACEHOLDER = PLACEHOLDERS['General question'];

  document.querySelectorAll('[data-contact-topics]').forEach((group) => {
    const form = group.closest('form');
    if (!form) return;

    const pills = [...group.querySelectorAll('[data-topic]')];
    const value = group.querySelector('[data-contact-topic-value]');
    const message = form.querySelector('[data-contact-message]');
    const orderField = form.querySelector('[data-contact-order-field]');
    if (!pills.length || !value) return;

    const select = (topic) => {
      pills.forEach((pill) => {
        pill.setAttribute('aria-pressed', String(pill.dataset.topic === topic));
      });
      value.value = topic;

      if (message) {
        message.placeholder = PLACEHOLDERS[topic] || DEFAULT_PLACEHOLDER;
      }

      if (orderField) {
        const wanted = topic === 'Order question';
        orderField.hidden = !wanted;
        // A hidden input would still post an empty value; clearing it keeps the
        // notification tidy when someone types a number and then switches topic.
        if (!wanted) {
          const input = orderField.querySelector('input');
          if (input) input.value = '';
        }
      }
    };

    pills.forEach((pill) => {
      pill.addEventListener('click', () => select(pill.dataset.topic));
    });

    // Sync the placeholder and order field to whatever is already pressed, so a
    // form that posted back with errors keeps the customer's topic in view.
    const pressed = pills.find((pill) => pill.getAttribute('aria-pressed') === 'true');
    if (pressed) select(pressed.dataset.topic);
  });
})();
